import { listPayments, type PaymentDetail } from '@/modules/payments/services/payments.service';
import { env } from '@/shared/lib/env';

const PORTAL_PAYMENTS_PAGE_SIZE = 100;

export async function fetchPortalPayments(): Promise<PaymentDetail[]> {
  return listPayments({ take: PORTAL_PAYMENTS_PAGE_SIZE });
}

export async function downloadPortalPaymentReceipt(
  paymentId: string,
  tenantId: string,
): Promise<void> {
  const url = new URL(`/api/v1/payments/${paymentId}/receipt`, env.VITE_API_URL);
  const response = await fetch(url.toString(), {
    method: 'GET',
    credentials: 'include',
    headers: { 'X-Tenant-Id': tenantId },
  });

  if (!response.ok) {
    const errorBody = (await response.json().catch(() => null)) as Record<string, unknown> | null;
    const nested = errorBody?.['error'] as Record<string, unknown> | undefined;
    const message =
      ((nested?.['message'] ?? errorBody?.['message']) as string | undefined) ??
      response.statusText;
    throw new Error(message || 'Failed to download receipt');
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  try {
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = `receipt-${paymentId.slice(0, 8)}.pdf`;
    anchor.rel = 'noopener';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
